﻿/**
 * portal-admin-groups.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-admin-groups.controller', portalAdminGroupsController);

	/** setup injection */
	portalAdminGroupsController.$inject = ['$uibModal', 'toastr', 'portal-link-group.repository'];

	/** implementation */
	function portalAdminGroupsController($uibModal, toastr, portalLinkGroupRepo) {
		/** pubic properties */
		var vm = this;
		vm.loading = false;
		vm.groups = [];

		/** public methods */
		vm.openGroupModal = openGroupModal;
		vm.reorder = reorder;

		/** run init */
		init();

		/** public method implementations */

		/** open a modal for group editing */
		function openGroupModal(group) {
			/** create the modal instance */
			$uibModal.open({
				templateUrl: 'app/portal-admin/portal-admin-groups/group-modal.html',
				controller: 'group-modal.controller',
				controllerAs: 'groupModalCtrl',
				size: 'lg',
				resolve: {
					portalGroup: function() {
						return group;
					},
					parentInit: function() {
						return init;
					}
				}
			});
		}

		/** reorder the groups */
		function reorder() {
			/** set the order number value */
			angular.forEach(vm.groups, function(g, index) {
				g.orderNumber = (index + 1);
			});

			/** save groups */
			portalLinkGroupRepo.reorder(vm.groups).then(function() {
				/** reset the users groups */
				portalLinkGroupRepo.resetGroups();

				/** show success message */
				toastr.success('Groups reordered successfully.', 'Save Successful', { positionClass: 'toast-bottom-right' });
			});
		}

		/** private methods */

		/** initialize */
		function init() {
			/** flip loading flag */
			vm.loading = true;

			/** load groups */
			portalLinkGroupRepo.getAll().then(function(groups) {
				/** set groups */
				vm.groups = groups;

				/** flip loading flag */
				vm.loading = false;
			});
		}
	}
})();